import { NgModule } from "@angular/core"
import { Routes, RouterModule } from "@angular/router"
import { LandingPageComponent } from "./landing-page.component"
import { AuthGuard } from "src/core/guards/auth.guard"
import { SsoHandlerComponent } from "../shared/sso-handler/sso-handler.component"
import { environment } from "src/environments/environment"

const path = environment.local ? environment.path : ""

const routes: Routes = [
  {
    path,
    children: [
      {
        path: '',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'serviziobea',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
	  },
	  {
		path: "serviziogba",
		component: LandingPageComponent,
		canActivate: [AuthGuard]
	  },
      {
        path: 'serviziobia',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'kit',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'nodo-operatore-attivo',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'nodo-operatore-attivo-dark-fiber',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'scuole',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'scuole-dark-fiber',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'dark-fiber',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'rete-primaria',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'rete-secondaria',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'sanita',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'sanita-dark-fiber',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'punti-intermedi',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'sopralluogo',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'servizio-wavelength',
        component: LandingPageComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'error',
        component: SsoHandlerComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LandingPageRouterModule { }
